export * from './auth.service';
import { AuthService } from './auth.service';
export * from './auth.serviceInterface';
export * from './health.service';
import { HealthService } from './health.service';
export * from './health.serviceInterface';
export * from './notifications.service';
import { NotificationsService } from './notifications.service';
export * from './notifications.serviceInterface';
export * from './permissions.service';
import { PermissionsService } from './permissions.service';
export * from './permissions.serviceInterface';
export * from './users.service';
import { UsersService } from './users.service';
export * from './users.serviceInterface';
export * from './utils.service';
import { UtilsService } from './utils.service';
export * from './utils.serviceInterface';
export * from './video.service';
import { VideoService } from './video.service';
export * from './video.serviceInterface';
export * from './videoScenes.service';
import { VideoScenesService } from './videoScenes.service';
export * from './videoScenes.serviceInterface';
export * from './videoUpload.service';
import { VideoUploadService } from './videoUpload.service';
export * from './videoUpload.serviceInterface';
export * from './websocket.service';
import { WebsocketService } from './websocket.service';
export * from './websocket.serviceInterface';
export * from './wiseIdAuth.service';
import { WiseIdAuthService } from './wiseIdAuth.service';
export * from './wiseIdAuth.serviceInterface';
export const APIS = [AuthService, HealthService, NotificationsService, PermissionsService, UsersService, UtilsService, VideoService, VideoScenesService, VideoUploadService, WebsocketService, WiseIdAuthService];
